import s from './style.css';
import cn from 'classnames';
import calcAreaPercentage from 'utils/calcAreaPercentage';
import TextWithBackground from 'components/TextWithBackground';

const positionsTop = [true, false, false, true];
const positionsLeft = [false, true, false, true];

const CircleGraph = ({ data, inView, isAlternative }) => (
	<div
		className={cn(s.vizContainer, {
			[s.hidden]: !inView,
			[s.alternative]: isAlternative
		})}
	>
		{data.map(({ percentage, fact }, i) => (
			<div
				className={cn(s.fact, {
					[s.factTop]: positionsTop[i],
					[s.factLeft]: isAlternative ? !positionsLeft[i] : positionsLeft[i]
				})}
			>
				<div
					className={s.responsive}
					style={{
						transitionDelay: `${0.2 * i}s`
					}}
				>
					<div
						className={s.bubbleWrap}
						style={{
							width: `${calcAreaPercentage(percentage, 65)}%`
						}}
					>
						<div className={s.bubble}>
							<div className={s.bubbleText}>{percentage}%</div>
						</div>
					</div>
				</div>

				<TextWithBackground
					bg={'transparent'}
					className={s.label}
					style={{
						transitionDelay: `${0.2 * i + 0.2}s`
					}}
				>
					{fact}
				</TextWithBackground>
			</div>
		))}
	</div>
);

export default CircleGraph;



// WEBPACK FOOTER //
// ./components/CircleGraph/index.js